import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { email, FormField, form, required } from '@angular/forms/signals';
import { SubscriptionService } from '../../../../services/subscription/subscription.service';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { ToastNotificationService } from '../../../../atoms/toast-notification/toast-notification.service';
import { ViewportOverlayDirective } from '../../../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'mb-share-payment-link',
  imports: [FormField],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './share-payment-link.html',
  styleUrl: './share-payment-link.css',
  host: {
    '(document:keydown.escape)': 'closeSharePaymentLink()'
  }
})
export class SharePaymentLink {

  @Output() close = new EventEmitter<void>();
  @Input() paymentLink: string = '';

  copiedLink = signal<boolean>(false);
  sendingRequest = signal<boolean>(false);
  requestSent = signal<boolean>(false);

  requestModel = signal({
    email: '',
    message: '',
  });
  requestForm = form(this.requestModel, (schemaPath) => {
    required(schemaPath.email, { message: 'Email is required' });
    email(schemaPath.email, { message: 'Enter a valid email address' });
  });

  /** Services */
  private subscriptionsService = inject(SubscriptionService);
  private currentUserService = inject(CurrentUserService);
  private toastNotificationService = inject(ToastNotificationService);
  /** Services - END */

  sendRequest() {
    if (this.requestForm().invalid()) {
      return;
    }
    this.sendingRequest.set(true);
    console.log('🤑🤑🤑 sendRequest() 🤑🤑🤑');
    console.log('requestForm: ', this.requestModel());

    this.subscriptionsService.sendApprovalRequest(this.currentUserService.focussedBrand?.stripeCustomerId, {
      email: this.requestModel().email,
      senderName: this.getApprovalSenderName(),
      message: this.requestModel().message || undefined,
      amount: `${this.currentUserService.currentSubscription()?.currency.toLowerCase() == 'gbp' ? '£' : '$'}${(this.currentUserService.currentSubscription()?.items.data[0]?.price.unit_amount / 100).toFixed(2)}`,
      companyName: this.currentUserService.focussedBrand?.companyName || 'SHOUT Studio',
      daysUntilDue: 7
    }).subscribe(response => {
      console.log('👉 response', response);
      this.sendingRequest.set(false);
      this.requestSent.set(true);
    }, error => {
      this.sendingRequest.set(false);
      this.toastNotificationService.alert({
        title: 'Failed to send approval request',
        message: 'Failed to send approval request',
        type: 'error',
        icon: 'error'
      }).then(() => {
        this.sendingRequest.set(false);
      });
    });

  }

  getApprovalSenderName() {
    return this.currentUserService.shoutUser?.firstName + ' ' + this.currentUserService.shoutUser?.lastName;
  }

  copyPaymentLink() {
    console.log('🤑🤑🤑 copyPaymentLink() 🤑🤑🤑');
    navigator.clipboard.writeText(this.paymentLink);
    this.copiedLink.set(true);
  }

  closeSharePaymentLink() {
    this.close.emit();
  }
}
